import type { inferParserType } from 'nuqs/server'
import { createSerializer } from 'nuqs/server'

import { dateParser } from './parsers/date.parser'
import { filterParsers } from './parsers/filter.parser'
import { locationParser } from './parsers/location.parser'
import { paginationParsers } from './parsers/pagination.parser'
import { paxParser } from './parsers/pax.parser'
import { polygonParser, zoomParser } from './parsers/polygon.parser'
import { productTypeParser } from './parsers/product-type.parser'

export type UrlState = inferParserType<typeof urlStateSchema>

export const urlStateSchema = {
  ...paxParser,
  ...dateParser,
  ...filterParsers,
  ...locationParser,
  ...paginationParsers,
  productType: productTypeParser,
  polygon: polygonParser,
  zoom: zoomParser,
}

export const URL_KEYS = {}

export const serializeUrlState = createSerializer(
  {
    ...urlStateSchema,
    // An omitted allocation restores cookies on the destination route. Links
    // carrying an explicit selection must preserve even the default occupancy.
    allocation: paxParser.allocation.withOptions({ clearOnDefault: false }),
  },
  { urlKeys: URL_KEYS }
)
